import { Consumer, NewConsumer } from '../../models/Entities/Consumer';
import { AppThunkAction } from '../reducers';
import { ErrorType } from '../../models/HttpError';

// services
import * as Services from '../../services/Consumer.Services';

// Actions
import * as Actions from '../actions/Consumer.Actions';

type KnownAction =
  | Actions.ConsumerGetAll_Request_Action
  | Actions.ConsumerGetAll_Receive_Action
  | Actions.ConsumerGetAll_Fail_Action
  | Actions.ConsumerUpdateAll_Request_Action
  | Actions.ConsumerUpdateAll_Receive_Action
  | Actions.ConsumerUpdateAll_Fail_Action
  | Actions.ConsumerGetById_Request_Action
  | Actions.ConsumerGetById_Receive_Action
  | Actions.ConsumerGetById_Fail_Action
  | Actions.ConsumerAdd_Request_Action
  | Actions.ConsumerAdd_Receive_Action
  | Actions.ConsumerAdd_Fail_Action
  | Actions.ConsumerUpdate_Request_Action
  | Actions.ConsumerUpdate_Receive_Action
  | Actions.ConsumerUpdate_Fail_Action
  | Actions.ConsumerDelete_Request_Action
  | Actions.ConsumerDelete_Receive_Action
  | Actions.ConsumerDelete_Fail_Action;

export const actionCreators = {
  GetAllConsumers: (): AppThunkAction<KnownAction> => async (dispatch, getState) => {
    const state = getState();
    let token: string;

    if (state.oidc?.user?.access_token === undefined) {
      dispatch({
        type: 'CONSUMER_GET_ALL_FAIL_ACTION',
        error: {
          ErrorCode: 401,
          ErrorMessage: 'Not authorized',
          Errors: []
        }
      });
      return;
    } else {
      token = state.oidc.user.access_token;
    }

    if (state.Consumers?.isLoadingAll || state.Consumers?.successLoadingAll) return;

    if (!state.Consumers?.successLoadingAll) {
      dispatch({
        type: 'CONSUMER_GET_ALL_REQUEST_ACTION'
      });

      Services.GetAllConsumers(token)
        .then((consumers: Consumer[]) => {
          dispatch({
            type: 'CONSUMER_GET_ALL_RECEIVE_ACTION',
            Consumers: consumers
          });
        })
        .catch((error: ErrorType) =>
          dispatch({
            type: 'CONSUMER_GET_ALL_FAIL_ACTION',
            error: error
          })
        );
    } else {
      dispatch({
        type: 'CONSUMER_UPDATE_ALL_REQUEST_ACTION'
      });

      Services.GetAllConsumers(token)
        .then((consumers: Consumer[]) => {
          dispatch({
            type: 'CONSUMER_UPDATE_ALL_RECEIVE_ACTION',
            Consumers: consumers
          });
        })
        .catch((error: ErrorType) =>
          dispatch({
            type: 'CONSUMER_UPDATE_ALL_FAIL_ACTION',
            error: error
          })
        );
    }
  },

  GetConsumerById:
    (consumerId: string): AppThunkAction<KnownAction> =>
    async (dispatch, getState) => {
      const state = getState();
      let token: string;

      if (state.oidc?.user?.access_token === undefined) {
        dispatch({
          type: 'CONSUMER_GET_BY_ID_FAIL_ACTION',
          error: {
            ErrorCode: 401,
            ErrorMessage: 'Not authorized',
            Errors: []
          }
        });
        return;
      } else {
        token = state.oidc.user.access_token;
      }

      dispatch({
        type: 'CONSUMER_GET_BY_ID_REQUEST_ACTION',
        ConsumerId: consumerId
      });

      Services.GetConsumerById(token, consumerId)
        .then((consumer: Consumer) => {
          dispatch({
            type: 'CONSUMER_GET_BY_ID_RECEIVE_ACTION',
            Consumer: consumer
          });
        })
        .catch((error: ErrorType) =>
          dispatch({
            type: 'CONSUMER_GET_BY_ID_FAIL_ACTION',
            error: error
          })
        );
    },

  AddConsumer:
    (newConsumer: NewConsumer): AppThunkAction<KnownAction> =>
    async (dispatch, getState) => {
      const state = getState();
      let token: string;

      if (state.oidc?.user?.access_token === undefined) {
        dispatch({
          type: 'CONSUMER_ADD_FAIL_ACTION',
          error: {
            ErrorCode: 401,
            ErrorMessage: 'Not authorized',
            Errors: []
          }
        });
        return;
      } else {
        token = state.oidc.user.access_token;
      }

      dispatch({
        type: 'CONSUMER_ADD_REQUEST_ACTION',
        NewConsumer: newConsumer
      });

      Services.CreateConsumer(token, newConsumer)
        .then((consumer: Consumer) => {
          dispatch({
            type: 'CONSUMER_ADD_RECEIVE_ACTION',
            Consumer: consumer
          });
        })
        .catch((error: ErrorType) =>
          dispatch({
            type: 'CONSUMER_ADD_FAIL_ACTION',
            error: error
          })
        );
    },

  UpdateConsumer:
    (consumer: Consumer): AppThunkAction<KnownAction> =>
    async (dispatch, getState) => {
      const state = getState();
      let token: string;

      if (state.oidc?.user?.access_token === undefined) {
        dispatch({
          type: 'CONSUMER_UPDATE_FAIL_ACTION',
          error: {
            ErrorCode: 401,
            ErrorMessage: 'Not authorized',
            Errors: []
          }
        });
        return;
      } else {
        token = state.oidc.user.access_token;
      }

      dispatch({
        type: 'CONSUMER_UPDATE_REQUEST_ACTION',
        Consumer: consumer
      });

      Services.UpdateConsumer(token, consumer.id, consumer)
        .then((updatedConsumer: Consumer) => {
          dispatch({
            type: 'CONSUMER_UPDATE_RECEIVE_ACTION',
            Consumer: updatedConsumer
          });
        })
        .catch((error: ErrorType) =>
          dispatch({
            type: 'CONSUMER_UPDATE_FAIL_ACTION',
            error: error
          })
        );
    },

  DeleteConsumer:
    (consumerId: string): AppThunkAction<KnownAction> =>
    async (dispatch, getState) => {
      const state = getState();
      let token: string;

      if (state.oidc?.user?.access_token === undefined) {
        dispatch({
          type: 'CONSUMER_DELETE_FAIL_ACTION',
          error: {
            ErrorCode: 401,
            ErrorMessage: 'Not authorized',
            Errors: []
          }
        });
        return;
      } else {
        token = state.oidc.user.access_token;
      }

      dispatch({
        type: 'CONSUMER_DELETE_REQUEST_ACTION',
        ConsumerId: consumerId
      });

      Services.DeleteConsumer(token, consumerId)
        .then(() => {
          dispatch({
            type: 'CONSUMER_DELETE_RECEIVE_ACTION',
            ConsumerId: consumerId
          });
        })
        .catch((error: ErrorType) =>
          dispatch({
            type: 'CONSUMER_DELETE_FAIL_ACTION',
            error: error
          })
        );
    }
};
